import { useContext } from "react"
import { useMutation } from "react-apollo"

import { SessionContext } from "contexts/session"

import { queryOptions } from "utils/helper"

import REACTIVATE_USER from "../../graphql/UserManagement/mutations/reactivateUser"

const useReactivateUserMutation = options => {
  const { user } = useContext(SessionContext)

  return useMutation(REACTIVATE_USER, {
    ...queryOptions(user, true),
    ...options,
    refetchQueries: ['FindOneUser'],
  });
}

export default useReactivateUserMutation
